import { ChangeDetectionStrategy, Component } from '@angular/core';

import { InstallationDetailsStore } from '@store';

@Component({
  selector: 'app-locked-system-error-banner',
  templateUrl: './locked-system-error-banner.component.html',
  styleUrls: ['./locked-system-error-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LockedSystemErrorBannerComponent {
  constructor(public installationDetailsStore: InstallationDetailsStore) {}
}
